<div class="block-edit-container m-t-lg">
  <div class="form-container">
    <div class="row close-button-row">
      <a role="button" class="close-button pull-right m-t-xs m-r-xs" (click)="goBack()">
        <i class="material-icons md-50">close</i>
      </a>
    </div>
    <!-- <div>Form valid: {{ form.valid }}</div> -->
    <div class="form-header row m-b-lg">
      <div class="form-title col-xs-9 col-sm-7">
        <span>{{ 'block.dialogTitle' | transloco }}</span>
      </div>
    </div>

    <form [formGroup]="form" errorTailor [arsultimaForm]="'.row'">
      <div class="row mb-3">
        <label for="ID" class="col-sm-2 col-form-label">{{ 'shared.reference' | transloco }}</label>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control"
            id="ID"
            formControlName="ID"
            readonly
            placeholder="{{ 'shared.reference' | transloco }}"
          />
        </div>
      </div>
      <div class="row mb-3">
        <label for="date_maj" class="col-sm-2 col-form-label">
          {{ 'shared.lastModified' | transloco }}
        </label>
        <div class="col-sm-4">
          <input
            type="text"
            class="form-control"
            id="date_maj"
            formControlName="date_maj"
            readonly
            placeholder="{{ 'shared.date' | transloco }}"
          />
        </div>
      </div>
      <div class="row mb-3">
        <label for="page" class="col-sm-2 col-form-label">{{ 'shared.page' | transloco }}</label>
        <div class="col-sm-4">
          <input type="text" class="form-control" id="page" formControlName="page" />
        </div>
      </div>
      <div class="row mb-3">
        <label for="rank" class="col-sm-2 col-form-label">
          {{ 'shared.displayRank' | transloco }}
        </label>
        <div class="col-sm-8 col-lg-7">
          <input
            type="number"
            min="1"
            max="100"
            class="form-control"
            id="rank"
            formControlName="rank"
            placeholder="Rank"
          />
          <div *ngIf="form.get('rank').value < 0" class="error">
            The value is too small
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <label for="blocktitle" class="col-sm-2 col-form-label">
          {{ 'shared.title' | transloco }}
        </label>
        <div class="col-sm-8 col-lg-7">
          <input
            type="text"
            class="form-control"
            id="blocktitle"
            formControlName="blocktitle"
            [placeholder]="'block.fieldTitlePlaceholder' | transloco"
          />
        </div>
      </div>
      <div class="row mb-3">
        <label for="blocksubtitle" class="col-sm-2 col-form-label">
          {{ 'shared.subtitle' | transloco }}
        </label>
        <div class="col-sm-8 col-lg-7">
          <input
            type="text"
            class="form-control"
            id="blocksubtitle"
            formControlName="blocksubtitle"
            [placeholder]="'block.fieldSubtitlePlaceholder' | transloco"
          />
        </div>
      </div>
      <div class="row mb-3">
        <label for="blocktext" class="col-sm-2 col-form-label">
          {{ 'shared.text' | transloco }}
        </label>
        <div class="col-sm-8 col-lg-10">
          <textarea
            type="textarea"
            class="form-control"
            id="blocktext"
            formControlName="blocktext"
            [placeholder]="'block.fieldTextPlaceholder' | transloco"
          ></textarea>
          <arsultima-markdown-helper></arsultima-markdown-helper>
        </div>
      </div>
      <div class="row mb-3">
        <div class="offset-md-2 offset-sm-2 col-sm-8">
          <arsultima-upload
            [form]="form"
            [disabled]="shouldDisableUpload"
            [loading]="uploading"
            [fileName]="fileName"
            [imageUrl]="imageUrl"
            [showRotate]="true"
            (rotateImage)="rotateImage($event)"
            (upload)="upload($event)"
            (delete)="deleteImage()"
          ></arsultima-upload>
        </div>
      </div>
      <arsultima-form-buttons
        [form]="form"
        [disableSave]="form.get('rank').value < 0"
        [showDelete]="id"
        (cancelClicked)="goBack()"
        (deleteClicked)="delete()"
        (saveClicked)="save()"
      ></arsultima-form-buttons>
    </form>
  </div>
</div>
